//import { useLocation } from 'react-router-dom';
//import { Popover, Grid, type MenuProps } from 'antd';
//import {MenuItem} from '../../../api/menu';
import { Menu } from 'antd';
import { getMenu, MenuItem, MenuList } from 'api/menu';
import { useLogout } from 'common/auth';
//import { AUTH_ROUTES } from 'features/auth/routes';
//import { useLogout } from 'common/auth';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const initMenu: MenuItem[] = [];

const Navbar1 = () => {
  const handleClick = useLogout();
  const [menus, setMenus] = useState(initMenu);
  const [isMenuLoading, setMenuLoading] = useState(true);
  useEffect(() => {
    setMenuLoading(true);
    // setIsLoading(false);
    debugger;
    const menuJson = sessionStorage.getItem('menus');
    if (!menuJson) {
      const roleId = sessionStorage.getItem('roleId');
      if (roleId) {
        getMenu(roleId).then((res) => {
          debugger;
          // setPagedList(res);
          //   setIsLoading(true);
          let menuByRole: MenuList;
          menuByRole = JSON.parse(res.data.toString().replace(/su,bmenu/g, 'submenu'));
          setMenus(menuByRole.menu);
          sessionStorage.setItem('menus', res.data.toString().replace(/su,bmenu/g, 'submenu'));
          // console.log(menus);
          setMenuLoading(false);
        });
      }
    } else {
      let menuByRole: MenuList;
      menuByRole = JSON.parse(menuJson);
      setMenus(menuByRole.menu);
      setMenuLoading(false);
    }
  }, []);

  return (
    <>
      <div style={{ margin: '20px' }}>
        {!isMenuLoading && menus.length > 0 ? (
          <Menu
            mode="horizontal"
            defaultSelectedKeys={['mail']}
            style={{ justifyContent: 'flex-end', backgroundColor: '#2c9897' }}
          >
            {menus.map((menu) =>
              menu.submenu ? (
                menu.submenu.length == 0 ? (
                  <Menu.Item key={menu.menuName.toString()}>
                    <Link to={menu.url.toString()}>{menu.menuName}</Link>
                  </Menu.Item>
                ) : (
                  <>
                    <Menu.SubMenu key={menu.menuName.toString()} title={menu.menuName.toString()}>
                      {menu.submenu.map(
                        (smenu) =>
                          // smenu.submenu ? (
                          smenu.submenu?.length == 0 ? (
                            <Menu.Item key={smenu.key.toString()}>
                              <Link to={smenu.url.toString()}>{smenu.menuName.toString()}</Link>
                            </Menu.Item>
                          ) : (
                            // <Menu.Item key={smenu.key.toString()}>
                            <Menu.SubMenu
                              key={smenu.menuName.toString()}
                              title={smenu.menuName.toString()}
                              className={'sub-submenu'}
                            >
                              {smenu.submenu?.map((ssmenu) => (
                                <Menu.Item key={ssmenu.key.toString()}>
                                  <Link to={ssmenu.url.toString()}>
                                    {ssmenu.menuName.toString()}
                                  </Link>
                                </Menu.Item>
                              ))}
                            </Menu.SubMenu>
                            // </Menu.Item>
                          )
                        // ) : <Menu.Item key={smenu.key.toString()}>
                        //   <Link to={smenu.url.toString()}>{smenu.menuName.toString()}</Link>
                        // </Menu.Item>
                      )}
                    </Menu.SubMenu>
                  </>
                )
              ) : null
            )}
            {/* <Menu.Item key="mail">
            <Link to="/app/dashboard">Dashboard</Link>
          </Menu.Item>
          <Menu.SubMenu key="Agent" title="Agent">
            <Menu.Item key="agentDashboard">
              <Link to="/agent/dashboard">Agent Dashboard</Link>
            </Menu.Item>
            <Menu.Item key="createLink">
              <Link to="/agent/create-link">Create Link</Link>
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu key="Receipt" title="Receipt">
            <Menu.Item key="create-receipt">
              <Link to="/receipt/create-receipt" className="linkcolor">
                Generate Receipt
              </Link>
            </Menu.Item>
            <Menu.Item key="receipt-dashboard">
              <Link to="/receipt/receipt-dashboard">Agent Receipt Dashboard</Link>
            </Menu.Item>
            <Menu.Item key="pending-receipt">
              <Link to="/receipt/pending-receipt">Pending for Receipt</Link>
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu key="User" title="User">
            <Menu.Item key="add-user">
              <Link to="/app/profile/add-user" className="linkcolor">
                Add User
              </Link>
            </Menu.Item>
            <Menu.Item key="change-password">
              <Link to="/app/profile/change-password">Change Password</Link>
            </Menu.Item>
            <Menu.Item key="add-partner">
              <Link to="/app/profile/add-partner">Add Admin</Link>
            </Menu.Item>
          </Menu.SubMenu> */}
            <Menu.Item key="logout">
              <Link to="/auth/login" onClick={handleClick}>
                Logout
              </Link>
            </Menu.Item>
          </Menu>
        ) : null}
      </div>
    </>
  );
};

export default Navbar1;
